import React from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

// ForceEditTriggerDialog lets operators override the auto-selected email trigger
// for a report row. It makes the current trigger explicit before allowing a manual override.
const ForceEditTriggerDialog = ({
  open,
  row,
  triggerId,
  triggerOptions,
  loadingTriggers = false,
  submitting = false,
  error = null,
  onTriggerChange,
  onClose,
  onSubmit,
  onClear,
}) => {
  const bac = row?.bac ?? '';
  const programName = row?.programName ?? '';
  const status = row?.newStatus ?? row?.currentStatus ?? '';
  const currentTriggerName = row?.emailTriggerName || '—';
  const currentTriggerId = row?.emailTriggerId || '—';

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Force Edit Trigger</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          <Typography variant="body2" color="text.secondary">
            Select a trigger to use for this row. Executing the trigger will send the selected
            trigger manually.
          </Typography>
          {error && <Alert severity="error">{error}</Alert>}
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <TextField label="BAC" value={bac} fullWidth InputProps={{ readOnly: true }} />
            <TextField label="Program" value={programName} fullWidth InputProps={{ readOnly: true }} />
          </Stack>
          <TextField label="Status" value={status} fullWidth InputProps={{ readOnly: true }} />
          <TextField
            label="Current Trigger"
            value={`${currentTriggerName} (${currentTriggerId})`}
            fullWidth
            InputProps={{ readOnly: true }}
          />
          <FormControl fullWidth disabled={loadingTriggers}>
            <InputLabel id="force-edit-trigger-label">Trigger</InputLabel>
            <Select
              labelId="force-edit-trigger-label"
              label="Trigger"
              value={triggerId}
              onChange={(event) => onTriggerChange(event.target.value)}
            >
              {triggerOptions.length === 0 && (
                <MenuItem value="" disabled>
                  {loadingTriggers ? 'Loading triggers…' : 'No triggers found'}
                </MenuItem>
              )}
              {triggerOptions.map((trigger) => (
                <MenuItem key={trigger.id} value={trigger.id}>
                  {trigger.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        {onClear && (
          <Button color="warning" onClick={onClear} disabled={submitting}>
            Reset to Auto
          </Button>
        )}
        <Button
          variant="contained"
          onClick={onSubmit}
          disabled={submitting || !triggerId}
        >
          {submitting ? 'Saving…' : 'Apply'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ForceEditTriggerDialog;
